import { EmptyState, Grid, GridRow, NoTasksIcon } from '@bp/ui-components';
import { AssignmentPreviewTeacher } from 'components/Assignments/components/AssignmentPreview/AssignmentPreviewTeacher';
import { useAssignments } from 'components/Assignments/hooks/useAssignments';
import { AssignmentModal } from 'components/Assignments/modals/AssignmentModal';
import { AssignmentsTeacherTable } from 'components/Assignments/tables/AssignmentsTeacherTable';
import { useRequireParams } from 'hooks/useRequireParams';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useWindowDimensions } from 'utils/dimensions';
import { BpCard } from '../../../../components/BpCard/BpCard';
import styles from './TeacherContent.module.scss';

export const CourseAssignmentsTeacherContent = () => {
  const { t } = useTranslation();
  const { courseUuid } = useRequireParams(['courseUuid']);
  const navigate = useNavigate();

  const {
    assignments,
    modalState,
    ConfirmationDialog,
    getAssignmentPath,
    handleCardDelete,
    handleTableDelete,
    handleEdit,
    loading,
  } = useAssignments({ courseUuid });

  const { isPhone, isTablet } = useWindowDimensions();

  function handleNavigate(assignmentUuid: string) {
    navigate(getAssignmentPath(assignmentUuid));
  }

  return (
    <div className={styles['course-assignmnets-teacher']}>
      {assignments.length === 0 ? (
        <EmptyState
          forcedHeight='40vh'
          title={t('assignments.noAssignments')}
          subtitle={t('assignments.createHint')}
          icon={<NoTasksIcon />}
        />
      ) : (
        <>
          <Grid>
            <GridRow>
              <AssignmentPreviewTeacher
                loading={loading}
                onNavigate={(uuid) => handleNavigate(uuid)}
                onEdit={(uuid) => handleEdit(uuid)}
                onDelete={(uuid) => handleCardDelete(uuid)}
              />
            </GridRow>
            <GridRow>
              <BpCard
                noPadding
                header={{
                  headline: t('assignments.future'),
                  subHeadline: !isPhone && !isTablet ? t('assignments.studentsCantSee') : undefined,
                }}
              >
                <div className={styles['mobile-hint']}>{t('assignments.studentsCantSee')}</div>
                <AssignmentsTeacherTable
                  type='future'
                  loading={!!loading && loading === 'table'}
                  onNavigate={(uuid) => handleNavigate(uuid)}
                  onEdit={(uuid) => handleEdit(uuid)}
                  onDelete={(uuid) => handleTableDelete(uuid)}
                />
              </BpCard>
            </GridRow>
            <GridRow>
              <BpCard noPadding header={{ headline: t('assignments.finishedAssignments') }}>
                <AssignmentsTeacherTable
                  type='past'
                  loading={!!loading && loading === 'table'}
                  onNavigate={(uuid) => handleNavigate(uuid)}
                  onEdit={(uuid) => handleEdit(uuid)}
                  onDelete={(uuid) => handleTableDelete(uuid)}
                />
              </BpCard>
            </GridRow>
          </Grid>

          <AssignmentModal {...modalState} />

          <ConfirmationDialog />
        </>
      )}
    </div>
  );
};
